import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundDecimal'
})
export class RoundDecimalPipe implements PipeTransform {

  transform(value: number | string, decimalPlaces: number = 2): number {
    if (value == null || isNaN(Number(value))) return 0; // Gérer les valeurs invalides
    const num = Number(value);
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(num * factor) / factor;
  }

}
